@use 'config' as config;

:host {
  overflow: hidden;

  ::slotted([slot='image-mosaic']) {
    display: block;
    z-index: 0;
    width: 100%;
    height: 100%;
    transition: transform 300ms ease-in-out;
    cursor: pointer;
    pointer-events: auto;
  }

  ::slotted([slot='image-mosaic']:hover) {
    transform: scale(1.1);

    @media (prefers-reduced-motion: reduce) {
      transform: none;
    }
  }

  ::slotted([slot='image-open']) {
    width: 100%;
    height: 100%;
  }

  .overlay-container {
    position: absolute;
    z-index: 1;
    transition:
      opacity 300ms,
      inset 0ms 300ms;
    opacity: 0;
    pointer-events: none;
    inset: 0;

    .overlay-image {
      position: absolute;
      width: var(--width, 100%);
      height: var(--height, 100%);
      overflow: hidden;
      transition: all 0ms 300ms;
      inset: var(--inset, 0);
    }

    ::slotted([slot='content']) {
      position: absolute;
      bottom: min(3rem, 4vw);
      left: min(2rem, 4vw);
      width: 80%;
      min-width: 10rem;
      max-width: 21rem;
      max-height: 80%;
      padding: 1rem 1.5rem;
      overflow: auto;
      transform: translateY(2rem);
      transition: none;
      opacity: 0;
      background-color: config.$image-gallery-content-background-color;
      box-shadow: config.$image-gallery-content-box-shadow;
    }
  }
}

:host([variant='high']) {
  grid-row: span 2 / span 2;
}

:host([variant='long']) {
  grid-column: span 2 / span 2;
}

:host(.overlay-open) {
  ::slotted([slot='image-mosaic']) {
    position: relative;
    transition-property: opacity transform;
    opacity: 0;
    pointer-events: none;
  }

  .overlay-container {
    transition: none;
    opacity: 1;
    pointer-events: auto;

    .overlay-image {
      width: 100%;
      height: 100%;
      transition: all 500ms cubic-bezier(0, 0, 0.2, 1);
      inset: 0;

      @media (prefers-reduced-motion: reduce) {
        transition: none;
      }
    }

    ::slotted([slot='content']) {
      transform: translateY(0);
      transition: all 500ms cubic-bezier(0, 0, 0.2, 1) 350ms;
      opacity: 1;

      @media (prefers-reduced-motion: reduce) {
        transition: none;
      }
    }
  }
}
